module.exports = __webpack_public_path__ + "47a9d456.svg";